import styled from '../../../styles/legacy/styled/styled'
import { GridLayout } from '../../shared/layout'

export const GridLayoutDocument = styled(GridLayout)`
  max-width: 1000px;
  margin: 0 auto;
`
